import React, { useState } from "react";
import { X } from "lucide-react";

const UpdatesSignupModal = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  //const deploymentId ='AKfycbwCmOtN5EHxoEO5XoEuh0twDEkTGJsMVHia-ucpwDDNkVeoqYytSb7zMHp_SBdSpHhf'

  const WEB_APP_URL =
    "https://script.google.com/macros/s/AKfycbwCmOtN5EHxoEO5XoEuh0twDEkTGJsMVHia-ucpwDDNkVeoqYytSb7zMHp_SBdSpHhf/exec";

  const handleSubmit1 = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      // Replace with your Formspree form ID for updates signup
      const response = await fetch("https://formspree.io/f/xvgzrpzd", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setSubmitStatus("success");
        setTimeout(() => {
          onClose();
          setSubmitStatus(null);
          setFormData({ name: "", email: "" });
        }, 2000);
      } else {
        setSubmitStatus("error");
      }
    } catch (error) {
      setSubmitStatus("error");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      const response = await fetch(WEB_APP_URL, {
        method: "POST",
        body: JSON.stringify({
          name: formData.name,
          email: formData.email,
        }),
      });
      console.log("Response from update Signup Modal:", response);
      if (response.ok) {
        setSubmitStatus("success");
        setTimeout(() => {
          onClose();
          setSubmitStatus(null);
          setFormData({ name: "", email: "" });
        }, 2000);
      } else {
        setSubmitStatus("error");
        console.error("Submission error:", await response.text());
      }
    } catch (error) {
      console.error("Submission error:", error);
      setSubmitStatus("error");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50"
      style={{
        fontFamily: "Inter",
        fontSize: "18px",
        color: "#4C4D5E",
      }}
    >
      <div className="bg-white rounded-lg w-full max-w-md relative">
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute right-4 top-4 text-gray-500 hover:text-gray-700"
          aria-label="Close modal"
        >
          <X size={24} />
        </button>

        {/* Modal content */}
        <div className="p-6">
          <h2
            className="text-2xl font-semibold mb-4"
            style={{
              fontFamily: "Inter",
              fontSize: "20px",
              fontWeight: 600,
              lineHeight: "34px",
              letterSpacing: "-0.025em",
              color: "#0E0444",
            }}
          >
            Stay Updated on ZetaFlow
          </h2>
          <p
            className="mb-6"
            style={{
              fontFamily: "Inter",
              fontSize: "16px",
              fontWeight: 600,
              lineHeight: "28px",
              letterSpacing: "-0.025em",
              color: "#0E0444",
            }}
          >
            Be the first to know about our latest features, updates, and launch
            dates.
          </p>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label
                htmlFor="name"
                className="block mb-2"
                style={{
                  fontFamily: "Inter",
                  fontSize: "14px",
                  fontWeight: 600,
                  lineHeight: "22px",
                  letterSpacing: "-0.0125em",
                  color: "#4C4D5E",
                }}
              >
                Full Name
              </label>
              <input
                type="text"
                id="name"
                name="name"
                placeholder="Enter your full name"
                value={formData.name}
                onChange={handleChange}
                className="w-full px-4 rounded-md border border-gray-300 bg-gray-100"
                required
              />
            </div>

            <div>
              <label
                htmlFor="email"
                className="block mb-2"
                style={{
                  fontFamily: "Inter",
                  fontSize: "14px",
                  fontWeight: 600,
                  lineHeight: "22px",
                  letterSpacing: "-0.0125em",
                  color: "#4C4D5E",
                }}
              >
                Email Address
              </label>
              <input
                type="email"
                id="email"
                name="email"
                placeholder="Enter your email address"
                value={formData.email}
                onChange={handleChange}
                className="w-full px-4 rounded-md border border-gray-300 bg-gray-100"
                required
              />
            </div>

            <button
              type="submit"
              className="w-full bg-[#0C60F2] text-white py-1.5 rounded-md font-semibold text-lg"
              style={{
                fontFamily: "Inter",
                fontSize: "14px",
                fontWeight: 600,
                lineHeight: "22px",
                letterSpacing: "-0.0125em",
                color: "#FFFFFF",
              }}
              disabled={isSubmitting}
            >
              {isSubmitting ? "Signing up..." : "Sign Up for Updates"}
            </button>

            {submitStatus === "success" && (
              <div className="text-green-600 text-center p-3 bg-green-50 rounded-md">
                Thanks for signing up! You'll hear from us soon.
              </div>
            )}
            {submitStatus === "error" && (
              <div className="text-red-600 text-center p-3 bg-red-50 rounded-md">
                Something went wrong. Please try again.
              </div>
            )}
          </form>
        </div>
      </div>
    </div>
  );
};

export default UpdatesSignupModal;
